<template>
	<v-card
		dark
		flat
		color="secondary"
		class="estates-container"
		height="100%"
	>
			<v-card-title primary class="title">
			Global System Variables
			</v-card-title>
			
			<v-card-title 
			v-if="!loadingSystemVariables"
			primary-title
			>
			<!--
			<span class="font-weight-light">
				     Market Value 1RE20 = 1€
			</span>
			-->

		</v-card-title>
		<v-card-text> 
			<v-layout v-if="!loadingSystemVariables" row	wrap>
				<v-flex xs12>
					<v-layout
						row 
						wrap
					>
						<v-flex>
							<!--
							<h6 class="body-1">
								Total RE20 Supply: {{ circulatingSupply }}
							</h6>
							-->
							<h4 class="font-weight-light">
								Market Value 1RE20 = 1€
							</h4>

							<h4 class="font-weight-light">
								RE721 Total Intrinsic Value: ...
								<!-- {{ re721IntrinsicValue }} -->
							</h4>
						</v-flex>
						<v-flex>
							<h4 class="font-weight-light">
								RE20 Total Circolating Supply: ...
								<!-- {{ circulatingSupplyNum }} -->
							</h4>
							<!--
							<h6 class="body-1">
								RE20 Intrinsic Value: {{ re20IntrinsicValue }}
							</h6>
							-->
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>	
			<v-layout v-else row	wrap>
				<v-spacer />
				<v-flex xs2>
					<v-progress-circular
						:size="50"
						color="primary"
						indeterminate
					/>
				</v-flex>
			</v-layout>
		</v-card-text>
	</v-card>
</template>

<script>
import {
	mapGetters,
	mapState,
	mapMutations
} from 'vuex'

export default {
	computed: {
		...mapGetters ([
			're20IntrinsicValue',
			're721IntrinsicValue',
			'loadingSystemVariables',
			'circulatingSupply'
		]),
		...mapState ({
			circulatingSupplyNum: state => state.ethereum.circulatingSupplyNum
		})
	},
	created: function () {
		this.getCirculatingSupply ()
	},
	methods: {
		...mapMutations (['getCirculatingSupply'])
	}
}
</script>

<style lang="scss" scoped>
.estates-container {
	border: 1px solid white !important;
}
</style>
